import { AuthenticateWithRedirectCallback } from "@clerk/clerk-react";

const SSOCallback = () => {
    const username = sessionStorage.getItem("redirectUsername");
    const completeUrl = username
        ? `/user/creator-list?username=${username}`
        : "/user/dashboard";

    return (
        <>
            <AuthenticateWithRedirectCallback
                afterSignInUrl={completeUrl}
                afterSignUpUrl={completeUrl}
            />
            <div className="min-h-screen gradient-bg-1 flex flex-col items-center justify-center p-6">
                <div className="flex flex-col items-center gap-6">

                    {/* Spinner */}
                    <div className="relative flex items-center justify-center">
                        <div className="absolute w-20 h-20 rounded-full bg-[#AF0056]/20 blur-xl animate-pulse"></div>
                        <div className="absolute w-16 h-16 rounded-full bg-[#AF0056]/10 blur-lg animate-pulse" style={{ animationDelay: '0.3s' }}></div>
                        <div className="w-12 h-12 rounded-full border-4 border-transparent border-t-[#AF0056] border-r-pink-400 animate-spin"></div>
                    </div>

                    {/* Text */}
                    <div className="text-center">
                        <h2 className="text-xl font-semibold text-foreground mb-1">
                            Signing you in...
                        </h2>
                        <p className="text-sm text-foreground/60">
                            Please wait while we set things up for you
                        </p>
                    </div>

                    {/* Animated dots */}
                    <div className="flex gap-1.5">
                        <span className="w-2 h-2 rounded-full bg-[#AF0056] animate-bounce" style={{ animationDelay: '0ms' }}></span>
                        <span className="w-2 h-2 rounded-full bg-[#AF0056] animate-bounce" style={{ animationDelay: '150ms' }}></span>
                        <span className="w-2 h-2 rounded-full bg-[#AF0056] animate-bounce" style={{ animationDelay: '300ms' }}></span>
                    </div>

                </div>
            </div>
        </>
    );
};

export default SSOCallback;
